<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              :customMdList="codes.allOption"
              :customSmdList="codes.selOption"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="searchCond"
              :selected="frame0.selectData.COD_PAGE_SEARCH_COND"
              codeId="COD_PAGE_SEARCH_COND"
              :defaultOption="'all'"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.selectData.searchText"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMA_00001'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-grid
            ref="grdOrgList"
            :showDisplayCountControl="false"
            :multiselect="true"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columns="gridOrgColumns"
            :columnsresize="true"
            :columnsautoresize="true"
            :dataset="'dsOrgData'"
            :initialPagesize="5"
            @rowselect="gridRowSelect('grdOrgList')"
            @rowunselect="gridRowSelect('grdOrgList')"
          />
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_right"
                :disabled="rightShiftEnable"
                @click="onRightShift"
              />
            </li>
            <li>
              <sui-button
                type="button"
                class="comm_btn_shut_left"
                :disabled="leftShiftEnable"
                @click="onLeftShift"
              />
            </li>
          </ul>
        </div>
        <div class="inbox">
          <sui-grid
            ref="grdTartList"
            :showDisplayCountControl="false"
            :multiselect="true"
            :pageable="false"
            :sortable="false"
            :filterable="false"
            :columns="gridTarColumns"
            :columnsresize="true"
            :columnsautoresize="true"
            :dataset="'dsTarData'"
            :initialPagesize="5"
            @rowselect="gridRowSelect('grdTartList')"
            @rowunselect="gridRowSelect('grdTartList')"
          />
          <div class="btn_wrap">
            <div class="info">
              {{ $t('MSG_TXT_PRMSN_LVL_DESC') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancel"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMA_00001'"
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMA_00001_P02', // eslint-disable-line vue/name-property-casing
  props: {
    parentPageId: {
      type: String,
      default: 'PGE_CMA_00001',
    },
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      roleId: '',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_PAGE_SEARCH_COND: {
            label: '',
            key: '',
          },
          searchText: '',
        },
      },
      localorgdata: [],
      localtardata: [],
      gridOrgColumns: [{
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }],
      gridTarColumns: [{
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }, {
        text: this.$t('MSG_TXT_ALL'),
        datafield: 'permissionAll',
        createwidget: (row, column, value, htmlElement) => {
          const editorFactory = utils.getGridCellFactory();
          const instance = editorFactory.createCellCheckbox(row, column, value, htmlElement, {
          }, this.dsTarData, this.$refs.grdTartList);
          instance.getComponentInstance().$on('input', () => {
            const data = instance.getCurrentDataRow();
            if (utils.isEqual(data.permissionAll, 'Y')) {
              data.permissionLevel = 63;
              data.permissionInstance.setValue(data.permissionLevel);
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '40px',
      }, {	  
        text: this.$t('MSG_TXT_PRMSN_LVL'),
        datafield: 'permissionLevel',
        createwidget: (row, column, value, htmlElement) => {
          const instance = utils.getGridCellFactory().createCellPermissionCheckbox(row, column, value, htmlElement, {
            checkDisabledFunction: this.permissionDisableState,
          }, this.dsTarData, this.$refs.grdTartList);
          const rowindex = instance.getDatasetIndex();
          this.dsTarData.data[rowindex].permissionInstance = instance.getComponentInstance();

          // utils.getGridCellFactory().createCellPermissionCheckbox(row, column, value, htmlElement, {
          // }, this.dsTarData, this.$refs.grdTartList);		  
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      searchFieldOldText: '',
      rightShiftEnable: true,
      leftShiftEnable: true,
      pmsDisableFlag: false,
      disabledYn: 'N',	  
    };
  },
  computed: {},
  watch: {
  },
  mounted() {
    if (this.dataList) {
      this.roleId = this.dataList[0].roleId;
      this.onSearchMappedPage();
    }
  },
  datasets: [{
    id: 'dsOrgData',
    type: 'local',
    data: 'localorgdata',
    datafields: [
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageName', type: 'string', map: 'pageName' },
    ],
  },
  {
    id: 'dsTarData',
    type: 'local',
    data: 'localtardata',
    datafields: [
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageName', type: 'string', map: 'pageName' },
      { name: 'permissionAll', type: 'string', map: 'permissionAll' },
      { name: 'permissionLevel', type: 'number', map: 'permissionLevel' },
      { name: 'permissionInstance', type: 'object', map: 'permissionInstance' },
    ],
  }],
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onReset() {
      // this.$refs.smComboFrame0.reset();
      this.frame0.selectData.COD_MDLE.key = 'ALL';
      this.frame0.selectData.COD_SMDLE.key = 'ALL';
      this.$refs.searchCond.reset();
      this.frame0.selectData.searchText = '';
    },
    onSearch() {
      const queryParams = {
        moduleCode: utils.trim(this.frame0.selectData.COD_MDLE.key),
        subModuleCode: utils.trim(this.frame0.selectData.COD_SMDLE.key),
        searchPageCond: utils.trim(this.frame0.selectData.COD_PAGE_SEARCH_COND.key),
        searchPageText: utils.trim(this.frame0.selectData.searchText),
      };

      http.request(this.parentPageId, 'DTS_CMU_00002', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          this.dsOrgData.setRawData(res.data);
        }
      });
    },
    onSearchMappedPage() {
      http.request(this.parentPageId, 'DTS_CMA_00034', {
        path: { 'role-id': this.roleId },
      }).then(res => {
        if (res.data) {
          utils.forEach(res.data, row => {
            row.permissionAll = 'N';
          });
          this.dsTarData.setRawData(res.data);
        }
      });
    },
    onRightShift() {
      // if (this.dsOrgData.data.length > 0) {
      //   const selectedIndexes = this.dsOrgData.getSelectedIndexes();
      //   const shiftData = [];
      //   utils.forEach(selectedIndexes, index => {
      //     if (!this.dsOrgData.data[index].permissionLevel) {
      //       this.dsOrgData.data[index].permissionLevel = 1;
      //     }
      //     shiftData.push(this.dsOrgData.data[index]);
      //   });
      //   this.dsOrgData.deleteRows(selectedIndexes);
      //   this.dsTarData.addRows(shiftData);
      //   this.dsOrgData.clearSelection();
      //   this.dsTarData.clearSelection();
      // }

      const selected = this.dsOrgData.getSelectedRawData();
      const added = this.dsTarData.getRawData();
      const newList = [];
      utils.forEach(selected, data => {
        if (utils.findIndex(added, { pageId: data.pageId }) === -1) {
          // const clone = utils.assign(data, { permissionLevel: 1 });
          const clone = utils.assign(data, { permissionLevel: 1, permissionAll: this.disabledYn });
          newList.push(clone);
        }
      });
      this.dsOrgData.clearSelection();
      this.dsTarData.addRows(newList);

    },
    onLeftShift() {
      // if (this.dsTarData.data.length > 0) {
      //   const selectedIndexes = this.dsTarData.getSelectedIndexes();
      //   const shiftData = [];
      //   utils.forEach(selectedIndexes, index => {
      //     shiftData.push(this.dsTarData.data[index]);
      //   });
      //
      //   this.dsTarData.deleteRows(selectedIndexes);
      //   this.dsOrgData.addRows(shiftData);
      //
      //   this.dsOrgData.clearSelection();
      //   this.dsTarData.clearSelection();
      // }
      const selected = this.dsTarData.getSelectedIndexes();
      this.dsTarData.deleteRows(selected);
    },
    permissionDisableState(rowData) {
      return this.pmsDisableFlag ? true :  utils.isEmpty(rowData) ? false : utils.isEqual(rowData.permissionAll, 'Y' );
    },
    onCancel() {
      this.$emit('cancel', '');
    },

    onSave() {
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_SAV_DATA'), null, () => {
        const saveList = [];
        utils.forEach(this.dsTarData.data, data => {
          const dataInfo = {
            roleId: this.roleId,
            roleObjectId: data.pageId,
            roleObjectTypeCode: 'P',
            permissionLevel: data.permissionLevel,
          };
          saveList.push(dataInfo);
        });

        const dataParams = {
          rolePageList: saveList,
        };

        http.request(this.parentPageId, 'DTS_CMA_00035', {
          path: { 'role-id': this.roleId },
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save', 'saved');
        });
      });
    },
    onKeyUpInput() {
      const searchFieldNewText = this.frame0.selectData.searchText;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.frame0.selectData.searchText = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    gridRowSelect(obj) {
      setTimeout(() => {
        const shiftBtnDisable = this.$refs[obj].ds.selectedRowIds.length > 0 ? false : true;
        if (obj === 'grdOrgList') {
          this.rightShiftEnable = shiftBtnDisable;
        } else {
          this.leftShiftEnable = shiftBtnDisable;
        }
      }, 2);      
    },
  },
};
</script>

  <style scoped>
  </style>
